module.exports = __webpack_public_path__ + "static/media/DeviceExtra2.354d105d.png";